import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  PortalResource,
  PortalResourceGetPaginatedEnrolments,
  PortalResourceGetPaginatedPendingInvitations,
} from 'src/resource/PortalResource/types';
import { ResourceApi } from 'src/resource/Resource';
import { selectCurrentInstitutionPath } from '../Institutions/CurrentInstitutionPath/selectors';
import { PORTAL } from '../resourceNames';
import { ReduxState } from '../state';

const ASYNC_THUNK_NAMESPACE = 'institutionAdminSettings';

export const getPaginatedEnrolments = createAsyncThunk<
  PortalResourceGetPaginatedEnrolments['return'] | null,
  PortalResourceGetPaginatedEnrolments['args'] | void,
  { state: ReduxState }
>(
  `${ASYNC_THUNK_NAMESPACE}/getPaginatedEnrolments`,
  async (args, { getState }) => {
    const state = getState();
    const currentInstitution = selectCurrentInstitutionPath(state);

    if (!currentInstitution) {
      return null;
    }

    const result = await ResourceApi.read<
      PortalResource,
      PortalResourceGetPaginatedEnrolments
    >(PORTAL, currentInstitution, 'getPaginatedEnrolments', { ...args });

    return result;
  }
);

export const getPaginatedPendingInvitations = createAsyncThunk<
  PortalResourceGetPaginatedPendingInvitations['return'] | null,
  PortalResourceGetPaginatedPendingInvitations['args'] | void,
  { state: ReduxState }
>(
  `${ASYNC_THUNK_NAMESPACE}/getPaginatedPendingInvitations`,
  async (args, { getState }) => {
    const state = getState();
    const currentInstitution = selectCurrentInstitutionPath(state);

    if (!currentInstitution) {
      return null;
    }

    const result = await ResourceApi.read<
      PortalResource,
      PortalResourceGetPaginatedPendingInvitations
    >(PORTAL, currentInstitution, 'getPaginatedPendingInvitations', {
      ...args,
    });

    return result;
  }
);
